import React from "react";
import { useTranslation } from "react-i18next";

function ContactUsBanner() {
  const { t } = useTranslation();
  return (
    <section className="country-banner">
      <div
        className="banner-details"
        style={{
          backgroundImage: "url('/images/webp/contact-banner.webp')",
        }}
      >
        <div className="d-sm-flex align-items-center justify-content-between gap-1 position-relative">
          <h2 className="f-s-36 f-w-400">{t("contact-us:title","Contact us")}</h2>
          <div className="contact-icons">
            <div className="icon-box">
              <img src="/images/svg/mail.svg" className="img-fluid" alt="" />
            </div>
            <div className="icon-box">
              <img src="/images/svg/phone.svg" className="img-fluid" alt="" />
            </div>
            <div className="icon-box">
              <img src="/images/svg/map.svg" className="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mt-sm-4 mt-2">
        <img src="/images/webp/contact-logo.webp" className="img-fluid" alt="" />
      </div>
    </section>
  );
}

export default ContactUsBanner;
